module.exports = __webpack_public_path__ + "img/list2_2.f9ccf464.png";